export class ConfigModel {
    constructor(rawData) {
        this._rawData = rawData;
    }
    get sharingData() {
        return this._rawData.social;
    }
    get statisticsData() {
        return this._rawData.statistics;
    }
    get chunkData() {
        return {
            url: decodeURI(this._rawData.chunk.url),
            count: this._rawData.chunk.count
        };
    }
    get linkDumpSubmitUrl() {
        return this._rawData.link_dump ? this._rawData.link_dump.submit_url : '';
    }
    get videoSettings() {
        return this._rawData.video_settings;
    }
    createImageUrl(file) {
        return this._rawData.staticUrl + 'images/' + file;
    }
}
